import React from 'react';
import { Container, Typography, Box, Paper, Grid, Chip } from '@mui/material';
import { Policy as PolicyIcon } from '@mui/icons-material';

const PoliciesStandards: React.FC = () => {
  const policies = [
    { name: 'Data Classification Policy', status: 'Active', version: '2.1' },
    { name: 'Access Control Standards', status: 'Active', version: '1.5' },
    { name: 'Data Retention Policy', status: 'Under Review', version: '3.0' },
    { name: 'Privacy & Security Standards', status: 'Active', version: '2.0' },
  ];

  return (
    <Container maxWidth="xl" sx={{ mt: 4, mb: 4 }}>
      <Box sx={{ mb: 4 }}>
        <Typography variant="h4" component="h1" sx={{ fontWeight: 600, color: '#003366', mb: 1, display: 'flex', alignItems: 'center', gap: 2 }}>
          <PolicyIcon sx={{ fontSize: 40 }} />
          Policies & Standards
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Manage data governance policies and standards
        </Typography>
      </Box>

      <Grid container spacing={3}>
        {policies.map((policy, index) => (
          <Grid item xs={12} md={6} key={index}>
            <Paper sx={{ p: 3 }}>
              <Typography variant="h6" sx={{ mb: 1, fontWeight: 600 }}>{policy.name}</Typography>
              <Box sx={{ display: 'flex', gap: 1, mb: 2 }}>
                <Chip label={policy.status} color={policy.status === 'Active' ? 'success' : 'warning'} size="small" />
                <Chip label={`v${policy.version}`} size="small" />
              </Box>
              <Typography variant="body2" color="text.secondary">
                Policy documentation and compliance requirements
              </Typography>
            </Paper>
          </Grid>
        ))}
      </Grid>

      <Paper sx={{ p: 4, mt: 3, textAlign: 'center', background: 'linear-gradient(135deg, #f5f5f5 0%, #e0e0e0 100%)', border: '2px dashed #003366' }}>
        <Typography variant="h5" sx={{ mb: 2, color: '#003366', fontWeight: 600 }}>
          🚧 Policy Management System Coming Soon
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Full policy lifecycle management, version control, approval workflows, and compliance tracking.
        </Typography>
      </Paper>
    </Container>
  );
};

export default PoliciesStandards;
